<script lang="ts" setup>
import Pagination2 from '@/components/Slider/Pagination2.vue';
import { Autoplay, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/vue';
import SwiperCore from 'swiper';
import 'swiper/css';
import 'swiper/css/pagination';
import type { IArticle } from '~/api/article';
SwiperCore.use([Autoplay, Pagination]);

const props = defineProps({
  data: {
    type: Array as PropType<IArticle[]>,
    default: 0
  }
});

const currentIndex: Ref<number> = ref(0);

// swiper
const swiperSlideSelector = ref();
const onSwiper = (data: any) => {
  //存放 swiper
  swiperSlideSelector.value = data;
};

const swiperTo = (index: number) => {
  swiperSlideSelector.value.slideTo(index);
};

const handelSwiperChange = (data: any) => {
  currentIndex.value = data.realIndex;
};

const handleSlidePrev = () => {
  swiperSlideSelector.value.slidePrev();
};
const handleSlideNext = () => {
  swiperSlideSelector.value.slideNext();
};

const handlePaginationChange = (index: number) => {
  swiperTo(index);
  currentIndex.value = index;
};
</script>

<template>
  <section class="banner">
    <div class="banner__inner">
      <swiper :autoplay="{
        delay: 3000
      }" :slides-per-view="1" :space-between="24" :speed="300" :loop="true" :breakpoints="{
        991: {
          slidesPerView: 1
        }
      }" class="banner__swiper" @swiper="onSwiper" @slide-change="handelSwiperChange">
        <swiper-slide v-for="item in data" :key="item.id">
          <div class="banner__swiper__item">
            <figure class="banner__swiper__pic">
              <Nimg :src="item?.image?.link" :alt="item?.image?.alt" :title="item?.image?.title" />
            </figure>
            <div class="banner__swiper__box">
              <div class="banner__swiper__title">{{ item.subject }}</div>
              <div class="banner__swiper__text" v-html="item.description"></div>
            </div>
          </div>
        </swiper-slide>
      </swiper>
      <div class="banner__bottom">
        <div class="banner__bottom__inner">
          <Pagination2 :currentIndex="currentIndex" @update:change="handlePaginationChange" :totalIndex="5"
            class="pagination-box__item white1" />
          <div class="banner__arrow arrow white1">
            <div class="arrow__prev" @click="handleSlidePrev">
              <svg-icon name="icon-arrow-right2" />
            </div>
            <div class="arrow__next" @click="handleSlideNext">
              <svg-icon name="icon-arrow-right2" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.banner {
  &__inner {
    position: relative;
    max-width: 100%;
  }

  &__swiper {
    width: 100%;
    max-width: 100%;

    &__pic {
      width: 100%;

      img {
        display: block;
        width: 100%;
      }
    }

    &__item {
      position: relative;

      @include max-media(767) {
        border-radius: toRem(6);
        overflow: hidden;
      }
    }

    &__box {
      background-color: $color-white-1;
      padding: toRem(24);
      border-radius: toRem(6);

      @include min-media(768) {
        position: absolute;
        left: toRem(30);
        bottom: toRem(30);
        width: 43%;
        border-radius: toRem(6);
      }
    }

    &__title {
      margin-bottom: toRem(12);
      font-size: toRem(22);
      font-weight: 500;
      line-height: 1.3;
    }

    &__text {
      font-size: toRem(16);
      font-weight: 400;
      line-height: 1.45;
    }
  }

  &__bottom {
    width: 100%;
    max-width: toRem(212);

    @include min-media(768) {
      position: absolute;
      right: toRem(30);
      bottom: toRem(30);
      z-index: 5;
    }

    @include max-media(767) {
      margin-top: toRem(24);
      margin-left: auto;
      margin-right: auto;
    }
  }

  &__arrow {
    display: flex;
    justify-content: space-between;
    margin-bottom: 0;
  }

  .arrow__prev,
  .arrow__next {
    border-color: $color-white-1;

    @include max-media(767) {
      border-color: $blue3;
      color: $blue3;
    }
  }

  :deep(.white1 .pagination) {
    @include max-media(767) {
      border-bottom-color: $blue3;
    }
  }

  :deep(.white1 .pagination-bar) {
    @include max-media(767) {
      background-color: $blue3;
    }
  }
}
</style>
